class QuickBuyCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.select?.exists) return

    this.handleChange = this.handleChange.bind(this)

    this.listeners.add(this.els.select.element, `change`, this.handleChange)
  }

  handleChange (event) {
    const variantAvailable =
      event.target.selectedOptions[0].getAttribute('data-available') === 'true'

    this.els['atc-button'].element.setAttribute(
      'aria-hidden',
      !variantAvailable,
    )
    this.els['view-button'].element.setAttribute(
      'aria-hidden',
      variantAvailable,
    )
  }
}

if (!customElements.get('quick-buy-card')) {
  customElements.define('quick-buy-card', QuickBuyCard)
}
